// extracted by mini-css-extract-plugin
export default {"Submenu":"Submenu_Submenu__xtquM","level3":"Submenu_level3__Vp8vz"};